import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LastSavedJobState {
  [key: string]: number; // Key is job name from JobNames, value is id
};

const initialState:LastSavedJobState = {};

interface LastSavedJobData {
  jobName: string,
  jobId: number,
};


/**
 * Slice for storing last saved Job id that needs to be tracked. Used for example to save
 * id of AiMbl that is not Direct when created. Users determine the logic which job types they
 * want to save.
 */
const lastSavedJobSlice = createSlice({
  name: 'lastSavedJob',
  initialState,
  reducers: {
    clearLastSavedJobs: () => initialState,
    setLastSavedJob: (state, action: PayloadAction<LastSavedJobData>) => {
      state[action.payload.jobName] = action.payload.jobId;
    },
  }
});

export default lastSavedJobSlice.reducer;

export const { clearLastSavedJobs, setLastSavedJob } = lastSavedJobSlice.actions;
